export const DEFAULT_COUNTRY = "India";

export function resolveProfileCountry(value) {
    const trimmed = String(value ?? "").trim();
    return trimmed || DEFAULT_COUNTRY;
}

/** Whitelisted body for POST/PUT /profile/business-details */
export function buildBusinessProfilePayload(formData = {}) {
    return {
        name: formData.name ?? "",
        tagline: formData.tagline ?? "",
        description: formData.description ?? "",
        industry: formData.industry ?? "",
        category: formData.category ?? "",
        country: resolveProfileCountry(formData.country),
        website: formData.website ?? "",
        location: formData.location ?? "",
        keywords: formData.keywords ?? "",
        uniqueness: formData.uniqueness ?? "",
    };
}

/** Map API / store profile into form state (no read-only server fields). */
export function pickProfileFormData(profile = {}) {
    return buildBusinessProfilePayload(profile);
}
